<template>
  <div class="mb_controller_home h-100 bg">
    <DesktopInterstitial v-if="desktop" />
    <MobileInterstitial v-else-if="mobile" />

    <mastheadCarousel />

    <div class="position-relative main-list-wrapper">
      <div class="main-list-section d-flex justify-content-center flex-column">
        <!-- ads top -->
        <billboardBannerTop v-if="desktop"></billboardBannerTop>
        <mrecBannerTop v-if="mobile"></mrecBannerTop>

        <div class="w-100 my-3 my-md-4">
          <HomepageCategoryRails
            :cat_id="716"
            :datasource="'vod'"
            :cat="'exclusives'"
            :title="'Must-Watch'"
          />
        </div>

        <div class="w-100 my-3 my-md-4">
          <HomepageCategoryRails
            :cat_id="943"
            :datasource="'vod'"
            :cat="'recommended'"
            :title="'Going Viral'"
          />
        </div>

        <HomepageTV class="my-4 my-xl-5" />
        <homepageRadio class="my-4 my-xl-5" />

        <!-- ads mid -->
        <!-- ads -->
        <billboardBannerMiddle v-if="desktop"></billboardBannerMiddle>
        <mrecBannerMiddle v-if="mobile"></mrecBannerMiddle>

        <HomepageContinueWatching v-if="initializeContinueWatchingRails" />

        <!-- sponsor rails -->
        <!-- <div class="w-100 my-2">
          <HomepageSponsorRails
            :cat_id="885"
            :datasource="'vod'"
            :cat="'festival'"
            :title="'Festival'"
          />
        </div> -->
        <!-- video -->
        <!-- <homepageVodCarousel class="my-4 my-xl-5" /> -->
        <homepageMoreVod class="my-3 my-xl-3" />

        <!-- podcast -->
        <HomepageLatestPodcast class="my-4 my-xl-5" />
        <!-- <homepagePodcast class="my-4 my-xl-5" /> -->

        <!-- ads bottom -->
        <billboardbannerbottom v-if="desktop"></billboardbannerbottom>
        <mrecbannerbottom v-if="mobile"></mrecbannerbottom>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import Vue from "vue";
import mastheadCarousel from "@/components/carousel/homepageMainCarousel";
import HomepageVodCarousel from "../components/carousel/homepageVodCarousel.vue";
import HomepageRadio from "../components/carousel/homepageRadio.vue";
import HomepageTV from "../components/carousel/homepageTV.vue";
import HomepageMoreVod from "../components/carousel/homepageMoreVod.vue";
import HomepagePodcast from "../components/carousel/homepagePodcast.vue";
import HomepageSponsorRails from "../components/carousel/homepageSponsorRails.vue";
import HomepageLatestPodcast from "../components/carousel/homepageLatestPodcast.vue";
import HomepageCategoryRails from "../components/carousel/vod/homepageFestivalRails.vue";
// ads
import billboardBannerTop from "../components/ads/v2/homepage/billboardBannerTop.vue";
import mrecBannerTop from "../components/ads/v2/homepage/mrecBannerTop.vue";
import billboardBannerMiddle from "../components/ads/v2/homepage/billboardBannerMiddle.vue";
import mrecBannerMiddle from "../components/ads/v2/homepage/mrecBannerMiddle.vue";
import BillboardBannerBottom from "../components/ads/v2/homepage/billboardBannerBottom.vue";
import MrecBannerBottom from "../components/ads/v2/homepage/mrecBannerBottom.vue";
import HomepageContinueWatching from "../components/carousel/homepageContinueWatching.vue";
import DesktopInterstitial from "../components/ads/v2/interstitial/desktopInterstitial.vue";
import MobileInterstitial from "../components/ads/v2/interstitial/mobileInterstitial.vue";

export default {
  data: function() {
    return {
      tablet: false,
      mobile: false,
      desktop: false,
      initializeContinueWatchingRails: false,
      loading: true,
    };
  },
  components: {
    mastheadCarousel: mastheadCarousel,
    homepageVodCarousel: HomepageVodCarousel,
    homepageRadio: HomepageRadio,
    homepageMoreVod: HomepageMoreVod,
    homepagePodcast: HomepagePodcast,
    HomepageSponsorRails,
    HomepageLatestPodcast,
    billboardBannerTop: billboardBannerTop,
    mrecBannerTop: mrecBannerTop,
    billboardBannerMiddle: billboardBannerMiddle,
    mrecBannerMiddle: mrecBannerMiddle,
    billboardbannerbottom: BillboardBannerBottom,
    mrecbannerbottom: MrecBannerBottom,
    HomepageContinueWatching,
    HomepageCategoryRails,
    DesktopInterstitial,
    MobileInterstitial,
    HomepageTV,
  },
  methods: {
    initializepageview() {
      var self = this;
      $.ajax({
        type: "POST",
        url: "https://rtb.glueapi.io/report/page-view",
        contentType: "application/json",
        data: JSON.stringify({
          href: self.$route.path,
          title: "home",
          site: "RTBGo",
        }),
        dataType: "json",
        success: function(data) {
          // console.log(data);
        },
        failure: function(errMsg) {
          console.log(errMsg);
        },
      });
    },
    checkFirstLoad() {
      var vm = this;

      Vue.nextTick(
        function() {
          setTimeout(
            function() {
              vm.loading = !vm.loading;
            }.bind(this),
            400
          );
        }.bind(vm)
      );
    },
  },
  created: function() {},
  mounted() {
    this.deviceCheck();
    setTimeout(
      function() {
        this.initializepageview();
      }.bind(this),
      200
    );
  },
  beforeMount() {
    const token = localStorage.getItem("token");
    if (token) {
      this.initializeContinueWatchingRails = true;
    }

    this.checkFirstLoad();
  },
};
</script>

<style scoped>
.main-list-wrapper {
  display: flex;
  justify-content: center;
  max-width: 100%;
  padding: 0 3%;
  margin-bottom: 4rem;
}
.main-list-section {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  overflow: hidden;
}
@media only screen and (max-width: 992px) {
  .main-list-section {
    overflow: unset;
  }
}
@media only screen and (max-width: 768px) {
  .mb_controller_home {
    margin-top: 0px;
  }

  .main-list-wrapper {
    margin-top: 24px;
    margin-bottom: 24px !important;
  }
  .main-list-section {
    margin: -4% auto 0;
  }
}
</style>
<style>
.mb_controller_home {
  overflow: hidden;
  max-width: 100%;
  margin: 0 auto;
}
.bg {
  background: #000000;
}
#latestVODCarousel .owl-prev span,
.owl-next span {
  color: #fff;
}

#latestVODCarousel .owl-prev span:hover,
#latestVODCarousel .owl-next span:hover {
  color: #8199a3;
}

#latestVODCarousel .owl-prev,
#latestVODCarousel .owl-next {
  position: absolute;
  top: 0;
  height: 100%;
}

#latestVODCarousel .owl-prev {
  left: 7px;
}

#latestVODCarousel .owl-next {
  right: 7px;
}
</style>
